import { useQuery } from '@tanstack/react-query';

import { fetchCategories } from '../services/svp/categories';

export const useAllSvpCategories = () => {
  return useQuery({
    queryKey: ['svp-all-categories'],
    queryFn: ({ signal }) => fetchCategories(undefined, signal),
  });
};
